import api from '../../utils/api'

export interface accountPayload {
  mobile: string;
  password: string;
  ['g-recaptcha-response']?: string;
}

export function fetchAccount(payload: accountPayload) {
  return api('/api/signin', 'POST', payload)
}

export function fetchAccountByToken() {
  return api('/api/signin/token', 'POST')
}
